export default function Rust_GetStarted() {
  return (
    <div>
      <h1>Rust_GetStarted Component</h1>
      <p>This is the Rust_GetStarted page.</p>
    </div>
  );
}
